import React from 'react';
import '../styles/AnimatedPostButton.css';

const AnimatedPostButton = ({ onClick, variant = 'desktop', text = 'Поделиться поездкой', theme = 'post' }) => {
  // Determine the wrapper class based on variant
  const wrapperClass = variant === 'mobile-fixed'
    ? `btn-wrapper btn-wrapper--mobile-fixed btn-wrapper--theme-${theme}`
    : `btn-wrapper btn-wrapper--${variant} btn-wrapper--theme-${theme}`;
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  const handleTouchStart = (e) => {
    // Prevent default touch behaviors that might cause movement
    e.stopPropagation();
  };

  const handleTouchEnd = (e) => {
    // Ensure click is triggered on touch end
    e.stopPropagation();
  };

  return (
    <div 
      className={wrapperClass}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick(e);
        }
      }}
      aria-label={text}
    >
      <svg className="dashed-border">
        <rect />
      </svg>
      
      <button className="btn-create-post" type="button">
        {text}
      </button>
    </div>
  );
};

export default AnimatedPostButton;

